<script setup lang="ts">
const emit = defineEmits<{
  (event: 'captchaStatus', value: { isValid: boolean, value: string }): void,
}>();
const captcha = ref('');
const inputCaptcha = ref('');

function checkCaptchaStatus(value: string) {
  const isValid = value === captcha.value.toLowerCase();
  emit("captchaStatus", { isValid, value });
}

function createCaptcha() {
  captcha.value = generateRandomCaptcha();
  captchaToImage(captcha.value);
};

function generateRandomCaptcha() {
  const symbols = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
  let tempCaptcha = "";
  for (let i = 0; i < 5; i++) {
    tempCaptcha += symbols[Math.floor(Math.random() * symbols.length)];
  }
  return tempCaptcha;
};

function captchaToImage(captchaCode: string) {
  const captchaContainer = document.getElementById("captchaContainer");
  if (!captchaContainer) 
    return;

  captchaContainer.innerHTML = "";
  const canvasWidth = captchaContainer.clientWidth;
  const canvasHeight = captchaContainer.clientHeight;
  const canvas = document.createElement("canvas");
  canvas.id = "captcha";
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  canvas.style.width = "100%";
  canvas.style.height = "100%";

  const context = canvas.getContext("2d")!;
  const fontSize = Math.floor(canvasHeight * 0.6);
  context.font = `bold ${ fontSize }px Arial`;
  const charSpacing = canvasWidth / captchaCode.length;
  const centerY = canvasHeight / 2 + fontSize / 3;

  captchaCode.split("").forEach((cTxt, index) => {
    const sDeg = (Math.random() * 30 * Math.PI) / 180;
    const x = charSpacing * index;
    const y = centerY;
    context.save();
    context.translate(x, y);
    context.rotate(sDeg);
    context.fillStyle = randomColor(true);
    context.fillText(cTxt, 0, 0);
    context.restore();
  });

  drawLines(context, canvasWidth, canvasHeight, 5);
  drawLines(context, canvasWidth, canvasHeight, 30);
  captchaContainer.appendChild(canvas);
};

function drawLines(context: CanvasRenderingContext2D, canvasWidth: number, canvasHeight: number, count: number) {
  for (let i = 0; i < count; i++) {
    context.strokeStyle = randomColor();
    context.beginPath();
    if (i < 5) {
      context.moveTo(Math.random() * canvasWidth, Math.random() * canvasHeight);
      context.lineTo(Math.random() * canvasWidth, Math.random() * canvasHeight);
    } else {
      const x = Math.random() * canvasWidth;
      const y = Math.random() * canvasHeight;
      context.moveTo(x, y);
      context.lineTo(x + 1, y + 1);
    }
    context.stroke();
  }
};

function randomColor(isText = false) {
  if (isText) {
    const colors = [
      "#002147",
      "#282C35",
      "#36454f",
      "#551a8b",
      "#100c08",
      "#3b3c36",
      "#003366",
      "#16161d",
      "#612302",
      "#343434",
      "#3d0c02",
    ];
    return colors[Math.floor(Math.random() * colors.length)]!;
  } else {
    const r = Math.floor(Math.random() * 256);
    const g = Math.floor(Math.random() * 256);
    const b = Math.floor(Math.random() * 256);
    return `rgb(${r}, ${g}, ${b})`;
  }
};

onMounted(() => {
  createCaptcha();
});

watch(
  () => inputCaptcha.value, (newVal) => {
    checkCaptchaStatus(newVal.toLowerCase());
  }
);
</script>

<template>
  <div 
    class="w-full h-10 flex items-center rounded-md overflow-hidden border border-[#E6E8EA] 
      focus-within:border-blue-500 transition-colors duration-300"
  >
    <input 
      type="text"
      class="bg-white w-[40%] h-full pr-2 rounded-none border-none"
      placeholder="کد امنیتی"
      v-model="inputCaptcha"
    >
    <div class="w-[60%] h-full flex items-center justify-between bg-[#D9D9D9] px-1 select-none">
      <div class="w-[80%] h-full flex justify-center items-center" id="captchaContainer" />
      <Icon
        name="solar:refresh-bold"
        class="cursor-pointer text-gray-500"
        size="24"
        @click="createCaptcha"
      />
    </div>
  </div>
</template>
